import { render, staticRenderFns } from "./PelletsStickyComparisonBar.vue?vue&type=template&id=f794864a"
import script from "./PelletsStickyComparisonBar.vue?vue&type=script&lang=ts"
export * from "./PelletsStickyComparisonBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports